import React from "react";
import { HashLink, HashLinkProps } from "react-router-hash-link";

interface IProps extends HashLinkProps {}

export default function RouterAnchorLink(props: IProps) {
    const { children, smooth = true, ...rest } = props;
    return (
        <HashLink smooth={smooth} {...rest}>
            {children}
        </HashLink>
    );
}
